import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PreferenceBaseModel } from '@shared/models/data/preferencebase-model';
import { ResidentModel } from '@shared/models/data/resident-model';
import { TransitionModel } from '@shared/models/data/transition-model';
import { EnrollmentService } from '@shared/services/enrollment.service';

@Component({
  selector: 'aaos-app-resident-transition-dialog',
  templateUrl: './resident-transition-dialog.component.html',
  styleUrls: ['./resident-transition-dialog.component.scss']
})
export class ResidentTransitionDialogComponent implements OnInit {

  formGroup: FormGroup;
  loading = false;
  transitionModel: TransitionModel = new TransitionModel();
  subSpecialtiesList: PreferenceBaseModel[];
  isFellowshipProgram: boolean;
  errors: string[];

  isFellowshipProgramControl = 'isFellowshipProgram';
  fellowshipProgramNameControl = 'fellowshipProgramName';
  fellowshipProgramLocationContol = 'fellowshipProgramLocation';
  fellowshipProgramSubspecialtyControl = 'fellowshipProgramSubspecialty';
  fellowshipBeginDateControl = 'fellowshipBeginDate';
  fellowshipEndDateControl = 'fellowshipEndDate';

  constructor(public residentTransitionDialogRef: MatDialogRef<ResidentTransitionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResidentModel,
    public enrollmentService: EnrollmentService) { }

  ngOnInit() {
    this.createFormGroup();
    this.populateForm();
  }

  closeDialog() {
    this.residentTransitionDialogRef.close();
  }

  radioChange(event) {
    this.isFellowshipProgram = event.value;
    if (this.isFellowshipProgram) {
      this.residentTransitionDialogRef.addPanelClass('double-column-dialog');
    } else {
      this.residentTransitionDialogRef.removePanelClass('double-column-dialog');
    }
  }

  onSubmit() {
    this.loading = true;

    const submittedTransition = new TransitionModel(this.formGroup.value);
    submittedTransition.id = this.transitionModel.id;
    submittedTransition.institutionId = this.transitionModel.institutionId;
    submittedTransition.nonInstitutionalEmailAddress = this.transitionModel.nonInstitutionalEmailAddress;

    this.enrollmentService.saveTransition(submittedTransition).subscribe(response => {
      this.errors = [];

      if (response.isValid) {
        this.residentTransitionDialogRef.close();
      } else {
        this.errors = response.errors;
      }

      this.loading = false;
    });
  }

  populateForm(): void {
    this.loading = true;
    this.enrollmentService.getTransitionSubspecialties().subscribe(lstSubSpecialty => {
      this.subSpecialtiesList = lstSubSpecialty;

      this.enrollmentService.getTransitionModel(this.data.institutionId, this.data.id).subscribe(transition => {
        this.transitionModel = transition;
        this.formGroup.controls[this.isFellowshipProgramControl].setValue(this.transitionModel.isFellowshipProgram);
        this.formGroup.controls[this.fellowshipProgramNameControl].setValue(this.transitionModel.fellowshipProgramName);
        this.formGroup.controls[this.fellowshipProgramLocationContol].setValue(this.transitionModel.fellowshipProgramLocation);
        this.formGroup.controls[this.fellowshipProgramSubspecialtyControl].setValue(this.transitionModel.fellowshipProgramSubspecialty);
        this.formGroup.controls[this.fellowshipBeginDateControl].setValue(this.transitionModel.fellowshipBeginDate);
        this.formGroup.controls[this.fellowshipEndDateControl].setValue(this.transitionModel.fellowshipEndDate);

        this.isFellowshipProgram = this.transitionModel.isFellowshipProgram;
        if (this.isFellowshipProgram) {
          this.residentTransitionDialogRef.addPanelClass('double-column-dialog');
        }

        this.loading = false;
      });
    });
  }

  createFormGroup() {
    this.formGroup = new FormGroup({
      isFellowshipProgram: new FormControl(this.transitionModel.isFellowshipProgram),
      fellowshipProgramName: new FormControl(this.transitionModel.fellowshipProgramName, [Validators.required]),
      fellowshipProgramLocation: new FormControl(this.transitionModel.fellowshipProgramLocation, [Validators.required]),
      fellowshipProgramSubspecialty: new FormControl(this.transitionModel.fellowshipProgramSubspecialty, [Validators.required]),
      fellowshipBeginDate: new FormControl(this.transitionModel.fellowshipBeginDate, [Validators.required]),
      fellowshipEndDate: new FormControl(this.transitionModel.fellowshipEndDate, [Validators.required])
    });
  }

  invalidRequiredField(fieldName: string): boolean {
    if (this.formGroup.get(fieldName).hasError('required')) {
      return true;
    }
    return false;
  }

  canSaveTransition(): boolean {
    // if they select the first option, enable
    // if they select the second option and the form is valid, enable
    return (this.formGroup.valid && this.formGroup.controls['isFellowshipProgram'].value === true) ||
            this.formGroup.controls['isFellowshipProgram'].value === false;
  }
}
